import { render, staticRenderFns } from "./StatusReasons.vue?vue&type=template&id=7bc9968e"
import script from "./StatusReasons.vue?vue&type=script&lang=js"
export * from "./StatusReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports